import { defineStore } from "pinia";

import { appInstance } from "shared/boot/app";
import ModalService from "shared/modals/ModalService";

type SearchScope = "all" | "journalists" | "streams";

interface RootState {
  searchOpen: boolean;
  searchQuery: string;
  searchScope: SearchScope;
}

const MODAL_NAME = "UniversalSearchModal";

// Mobile renders the search itself (see apps/mobile/src/App.vue) as a surface
// that takes over the viewport, so only desktop drives the modal container.
// `appInstance` is only assigned once the app boots, so it is absent under test.
function usesModal() {
  return !appInstance?.config.globalProperties.$isMobile;
}

export const useUniversalSearchStore = defineStore("universalSearch", {
  actions: {
    hideSearch() {
      this.searchOpen = false;

      if (usesModal()) ModalService.close(MODAL_NAME);
    },
    setSearchQuery(query: string) {
      this.searchQuery = query;

      if (this.searchQuery) this.showSearch();
    },
    setSearchScope(scope: SearchScope) {
      this.searchScope = scope;
    },
    showSearch() {
      if (this.searchOpen) return;

      this.searchOpen = true;

      if (usesModal()) ModalService.open(MODAL_NAME);
    },
  },
  state: (): RootState => ({
    searchOpen: false,
    searchQuery: "",
    searchScope: "streams",
  }),
});

export default useUniversalSearchStore;
